import { createFileRoute } from "@tanstack/react-router";
import { PracticeMasterPage, practiceMasterHead } from "@/components/site/PracticeMasterPage";
import { practiceMasterPages } from "@/data/practice-master-pages";

const page = practiceMasterPages[5];
export const Route = createFileRoute("/practice-areas/dui-dwi-lawyer-seo")({
  head: () => practiceMasterHead(page),
  component: () => <PracticeMasterPage page={page} />,
});
